// Вкладки страницы /administration. Видимость дублирует серверные проверки соответствующих эндпоинтов.
export const ADMIN_TAB = Object.freeze({
    STRUCTURE: 'structure',
    USERS: 'users',
    CALCULATOR: 'calculator',
    SCREEN_PACKAGES: 'screen-packages',
    AIRTIME_CERTIFICATE: 'airtime-certificate',
    ACTIVITY_LOG: 'activity-log',
    SCORING: 'scoring',
});

export const ADMIN_TAB_GROUP = Object.freeze({
    OPS: 'ops',
    TOOLS: 'tools',
});

export const ADMIN_TAB_GROUP_LABEL = Object.freeze({
    [ADMIN_TAB_GROUP.TOOLS]: 'Инструменты',
});

const isAdmin = actor => Boolean(actor?.is_admin);
const isAdminOrAgency = actor => Boolean(actor?.is_admin || actor?.is_agency);

export const ADMIN_TABS = Object.freeze([
    { id: ADMIN_TAB.STRUCTURE, label: 'Структура', group: ADMIN_TAB_GROUP.OPS, isVisibleTo: () => true },
    { id: ADMIN_TAB.USERS, label: 'Пользователи', group: ADMIN_TAB_GROUP.OPS, isVisibleTo: () => true },
    { id: ADMIN_TAB.CALCULATOR, label: 'Калькулятор', group: ADMIN_TAB_GROUP.TOOLS, isVisibleTo: isAdminOrAgency },
    { id: ADMIN_TAB.SCREEN_PACKAGES, label: 'Пакеты экранов', group: ADMIN_TAB_GROUP.TOOLS, isVisibleTo: isAdmin },
    { id: ADMIN_TAB.AIRTIME_CERTIFICATE, label: 'Эфирная справка', group: ADMIN_TAB_GROUP.TOOLS, isVisibleTo: isAdmin },
    { id: ADMIN_TAB.ACTIVITY_LOG, label: 'Журнал действий', group: ADMIN_TAB_GROUP.TOOLS, isVisibleTo: isAdmin },
    { id: ADMIN_TAB.SCORING, label: 'Скоринг', group: ADMIN_TAB_GROUP.TOOLS, isVisibleTo: isAdmin },
]);

export const DEFAULT_ADMIN_TAB = ADMIN_TAB.STRUCTURE;

export const adminSubtitle = (actor) => {
    if (actor?.is_admin) return 'Структура и наценки, пользователи и инструменты платформы';
    if (actor?.is_agency) return 'Структура и наценки, пользователи и калькулятор';
    return 'Управление доступными сущностями';
};
